export const NUMBER_OF_LEVERAGE_PRODUCT_OPTIONS = 1;
export const SAVINGS_PLAN_TAG = "savings-plan";
export const REAL_MONEY_TAG = "real-money";

export const TAG_IDS_IS_INVESTABLE = [SAVINGS_PLAN_TAG, REAL_MONEY_TAG];

export const SEARCH_COMMIT_WAIT_MILLISECONDS = 650;
export const SEARCH_COMMIT_MAX_WAIT_MILLISECONDS = 350;
